export class EmployeeStatus {
  SequenceNumber: number;
  StatusId: number;
  DateStatusChange: Date;
  ReasonSequenceNumber: number;
  StatusDescription: string;

  constructor(status: number, date: Date, reason: number) {
    this.StatusId = status;
    this.DateStatusChange = date;
    this.ReasonSequenceNumber = reason;
  }
}
